import Section from "components/common/Section";
import StaticPageHeader from "components/common/StaticPageHeader";
import usePageMeta from "hooks/usePageMeta";

const PrivacyPolicy = () => {
  usePageMeta(
    "Privacy Policy | Transform the world through revealed knowledge",
    "Read the Ubay.pk privacy policy. We collect only the information needed to run your account and deliver the daily Islamic quiz. We never sell your personal data.",
    "/privacy"
  );

  return (
    <div className="min-h-screen relative">
      {/* Background */}
      <img src="/assets/imgs/bg.jpg" alt="" className="fixed inset-0 h-full w-full object-cover -z-10" />

      <StaticPageHeader currentPage="Privacy Policy" />
      <Section asMain>
        <div className="py-8 sm:py-12">
          <div className="max-w-4xl mx-auto space-y-6">

            {/* Hero */}
            <div className="bg-white/80 backdrop-blur-2xl border border-white/40 rounded-2xl p-6 sm:p-8 shadow-xl">
              <p className="text-sm font-semibold text-emerald-600 mb-2">Privacy first</p>
              <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 mb-3">Privacy Policy</h1>
              <p className="text-slate-700 text-base sm:text-lg leading-relaxed">
                Ubay.pk is a non-profit platform. We collect only the information needed to run your account and deliver the daily question experience. We do not sell or rent your personal data.
              </p>
            </div>

            {/* Sections */}
            <div className="space-y-4">
              <div className="bg-white/80 backdrop-blur-2xl border border-white/40 rounded-2xl p-5 sm:p-6 shadow-lg space-y-3">
                <h2 className="text-lg sm:text-xl font-semibold text-slate-900">Information we collect</h2>
                <ul className="list-disc list-inside text-slate-700 text-sm sm:text-base space-y-1.5">
                  <li>Email address for account creation, login, and essential communication.</li>
                  <li>Reading and answer history to personalize recommendations.</li>
                  <li>Log data (IP, browser type, pages visited, timestamps) for security and performance.</li>
                </ul>
              </div>

              <div className="bg-white/80 backdrop-blur-2xl border border-white/40 rounded-2xl p-5 sm:p-6 shadow-lg space-y-3">
                <h2 className="text-lg sm:text-xl font-semibold text-slate-900">How we use your data</h2>
                <ul className="list-disc list-inside text-slate-700 text-sm sm:text-base space-y-1.5">
                  <li>Account creation, authentication, and recovery.</li>
                  <li>Personalization of your daily question journey.</li>
                  <li>Service updates and essential notices (you can unsubscribe from non-essential emails).</li>
                </ul>
              </div>

              <div className="bg-white/80 backdrop-blur-2xl border border-white/40 rounded-2xl p-5 sm:p-6 shadow-lg space-y-3">
                <h2 className="text-lg sm:text-xl font-semibold text-slate-900">Your rights</h2>
                <ul className="list-disc list-inside text-slate-700 text-sm sm:text-base space-y-1.5">
                  <li>Access, correct, or delete your data.</li>
                  <li>Restrict or object to processing, where applicable.</li>
                  <li>Request data portability.</li>
                </ul>
              </div>

              <div className="bg-white/80 backdrop-blur-2xl border border-white/40 rounded-2xl p-5 sm:p-6 shadow-lg space-y-3">
                <h2 className="text-lg sm:text-xl font-semibold text-slate-900">Cookies & analytics</h2>
                <ul className="list-disc list-inside text-slate-700 text-sm sm:text-base space-y-1.5">
                  <li>Necessary cookies keep the site secure and functional.</li>
                  <li>Analytics cookies (e.g., Google Analytics) help us understand usage; data is aggregated and not sold.</li>
                </ul>
              </div>

              <div className="bg-white/80 backdrop-blur-2xl border border-white/40 rounded-2xl p-5 sm:p-6 shadow-lg space-y-3">
                <h2 className="text-lg sm:text-xl font-semibold text-slate-900">Data protection</h2>
                <ul className="list-disc list-inside text-slate-700 text-sm sm:text-base space-y-1.5">
                  <li>Industry-standard safeguards to prevent unauthorized access, alteration, or loss.</li>
                  <li>We do not sell, trade, or rent personal information.</li>
                  <li>Account deletion removes your personal data from our systems within a reasonable timeframe.</li>
                </ul>
              </div>

              <div className="bg-emerald-50/90 backdrop-blur-xl border border-emerald-200/60 rounded-2xl p-5 sm:p-6 shadow-lg space-y-3">
                <h2 className="text-lg sm:text-xl font-semibold text-slate-900">Contact</h2>
                <p className="text-slate-700 text-sm sm:text-base leading-relaxed">
                  Questions about privacy? Reach <span className="font-semibold">Ubay Platform</span> at
                  <a className="ml-1 underline text-emerald-700 decoration-emerald-200 hover:decoration-emerald-500" href="mailto:ubayplatform@gmail.com">ubayplatform@gmail.com</a>.
                </p>
              </div>
            </div>

          </div>
        </div>
      </Section>
    </div>
  );
};

export default PrivacyPolicy;
